import React from 'react';
import { useForm } from 'react-hook-form';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import postConstituentIWave from '@/services/postConstituentIWave';

type FormValues = {
  iwaveUniqueScreeningId: string;
};

export default function useConstituentIWaveConnectForm(constituentId: string) {
  const ownerOrgId = useOwnerOrgId();
  const [iWaveId, setIWaveId] = React.useState('');
  const [hasConnection, setHasConnection] = React.useState(false);
  const [connectionError, setConnectionError] = React.useState<null | string>(
    null,
  );

  const {
    control,
    formState: { errors, isSubmitting, isValid },
    handleSubmit,
    watch,
  } = useForm<FormValues>({
    defaultValues: {
      iwaveUniqueScreeningId: '',
    },
    mode: 'all',
  });

  const hasIWaveId = !!watch('iwaveUniqueScreeningId');
  const onSubmit = React.useCallback(
    handleSubmit(async (formData: FormValues) => {
      try {
        const { iwaveUniqueScreeningId } = formData;

        await postConstituentIWave({
          constituentId,
          iwaveUniqueScreeningId,
          ownerOrgId,
        });

        setHasConnection(true);
        setIWaveId(formData.iwaveUniqueScreeningId);
      } catch (e) {
        if (e instanceof Error) {
          setConnectionError(e.message);
        }
      }
    }),
    [constituentId, ownerOrgId],
  );

  const onEditClick = () => {
    setHasConnection(false);
  };

  return {
    connectionError,
    control,
    errors,
    hasConnection,
    hasIWaveId,
    isSubmitting,
    isValid,
    iWaveId,
    onEditClick,
    onSubmit,
  };
}
